import { createApiActions } from '../../../helpers/actions';

export const getCustomersList = createApiActions()(
  'company/getCustomersList',
  'company/getCustomersListSuccess',
  'company/getCustomersListError',
  () => {}
);
